export const DOCUMENTATION_URL =
  import.meta.env.VITE_APP_DEMO_URL || 'https://tucutable.netlify.app';
export const GITHUB_URL = 'https://github.com/e-burgos/tucutable';
export const INTRODUCTION_DOCS_URL = `${DOCUMENTATION_URL}/`;
export const TAILWIND_UTILITIES_DOCS_URL = 'https://tailwindcss.com/docs';
